// Set body padding for fixed menu
const primaryMenu = document.querySelector('#primary-menu');
const primaryMenuHeight = (primaryMenu) ? primaryMenu.offsetHeight : 0;

const menuOffset = primaryMenuHeight;

function containerPadding() {
    document.body.style.paddingTop = menuOffset - 1 + 'px';
}

// Hamburger open/close animation
function hamburgerMenu() {
    const hamburgerMenu = document.querySelectorAll('.burger');

    hamburgerMenu.forEach(function (item, index) {
        item.addEventListener('click', function () {
            item.classList.toggle('burger-active');
        });
    });
}

// Hide carousel indicator if slide not present
function hideCarouselIndicators() {

    const carouselEl = document.querySelector('#courtroom-postcard-mistery-carousel');

    if (carouselEl === null) {
        return
    }

    const items = carouselEl.querySelectorAll('.carousel-item');
    const prev = carouselEl.querySelector('.carousel-control-prev');
    const next = carouselEl.querySelector('.carousel-control-next');

    function updateControls(index) {
        prev.classList.toggle('is-disabled', index === 0);
        next.classList.toggle('is-disabled', index === items.length - 1);
    }

    carouselEl.addEventListener('slid.bs.carousel', function (event) {
        updateControls(event.to);
    });

    updateControls(0);
}

// Fix background parallax on > 1920px screens
function fixBgParallax() {
    const mainBg = document.querySelector('.parallax-main-bg');

    if (mainBg === null) {
        return
    }

    mainBg.setAttribute('data-speed', '0.9');
}

const mediaQuery = window.matchMedia('(min-width: 1921px)');
if (mediaQuery.matches) {
    fixBgParallax();
}

containerPadding();
hamburgerMenu();
hideCarouselIndicators();

/**
 * Webshop links - open a modal with links to the webshop of the selected region
 */
function initWebshopModal() {

    document.addEventListener('DOMContentLoaded', function() {

        const modalElement = document.getElementById('webshopModal');

        if (!modalElement) {
            return;
        }

        const modalBody = modalElement.querySelector('.links-container');

        const triggers = document.querySelectorAll('.webshop-modal-trigger');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', function(e) {

                e.preventDefault();

                // Parse URLs from data attribute
                const urlsJson = this.getAttribute('data-webshop-url');
                let urls;

                try {
                    urls = JSON.parse(urlsJson);
                } catch (error) {
                    console.error('Error parsing webshop URLs:', error);
                    return;
                }

                // Build and inject the links
                if (typeof urls === 'object' && urls !== null) {

                    const links = Object.values(urls)
                        .map(url => `
                            <li class="mb-2">
                                <a href="${url.url}" class="btn btn-primary w-100" target="_blank">
                                    ${url.title}
                                </a>
                            </li>
                        `)
                        .join('');

                    modalBody.innerHTML = `<ul class="list-unstyled mb-0">${links}</ul>`;
                }

                // Show the modal
                new bootstrap.Modal(modalElement).show();
            });
        });
    });
}
initWebshopModal();
